// src/components/about/ContentCard.js
import React from 'react';
import AnimateOnScroll from './AnimateOnScroll'; // Adjust path as needed

const ContentCard = ({ title, italicText, paragraphText, imageUrl, imageAlt, linkHref, linkText, imagePosition = 'left' }) => {
  const imageOrder = imagePosition === 'left' ? 1 : 2;
  const textOrder = imagePosition === 'left' ? 2 : 1;

  return (
    <AnimateOnScroll>
      <div style={{
        marginBottom: '60px',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: '40px',
        alignItems: 'center',
      }}>
        {/* Image Column */}
        <div style={{
          flex: '1 1 300px', // Allow flexible sizing
          minWidth: '280px', // Minimum width before wrapping
          order: imageOrder, // Control position
        }}>
          <img
            src={imageUrl}
            alt={imageAlt}
            style={{
              width: '100%',
              height: 'auto', // Maintain aspect ratio
              borderRadius: '4px',
              display: 'block', // Prevent extra space below image
            }}
          />
        </div>

        {/* Text Column */}
        <div style={{
          flex: '1 1 400px', // Allow flexible sizing, prefer text width
          minWidth: '300px',
          order: textOrder, // Control position
        }}>
          <h2 style={{ fontSize: '1.8rem', fontWeight: 'normal', marginTop: 0, marginBottom: '20px', color: '#000' }}>
            {title}
          </h2>
          {italicText && (
            <p style={{ fontStyle: 'italic', fontSize: '1.1rem', marginBottom: '20px', color: '#4b5563' }}>
              {italicText}
            </p>
          )}
          <p style={{ lineHeight: '1.6', fontSize: '1rem', color: '#4b5563' }}>
            {paragraphText}
            {linkHref && linkText && (
               <> {/* Use fragment */}
                 {' '} {/* Add space before link */}
                 <a href={linkHref} style={{ color: '#2563eb', textDecoration: 'none', fontWeight: '500' }}>
                   {linkText}
                 </a>
               </>
            )}
          </p>
        </div>
      </div>
    </AnimateOnScroll>
  );
};

export default ContentCard;